<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2021 by Anna Lvovsky</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2021</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">30 29 28 27 26 25 24 23 22 21    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-76964-6 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-76978-3 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-76981-3 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226769813.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226769813.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Lvovsky, Anna, author.</p>
<p class="cip">Title: Vice patrol : cops, courts, and the struggle over urban gay life before Stonewall / Anna Lvovsky.</p>
<p class="cip">Other titles: Cops, courts, and the struggle over urban gay life before Stonewall</p>
<p class="cip">Description: Chicago ; London : University of Chicago Press, 2021. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2020045745 | ISBN 9780226769646 (cloth) | ISBN 9780226769783 (paperback) | ISBN 9780226769813 (ebook)</p>
<p class="cip">Subjects: LCSH: Male homosexuality—United States—History—20th century. | Gays—Legal status, laws, etc.—United States. | Vice control—United States—History—20th century. | Law enforcement—United States—History—20th century.</p>
<p class="cip">Classification: LCC HQ76.3.U6 L96 2021 | DDC 306.76/60973—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2020045745" target="_blank">https://lccn.loc.gov/2020045745</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper)</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lvovsky-0004.vue?1c85bf7e